import {Modal, Box, Flex, Card, Text} from 'rimble-ui'

export default function ModalSwitchNetwork(props) {
  const {toggleModal, switchNetwork} = props

  return (
    <>
      <Modal isOpen={toggleModal} className='modalOptionConnect'>
        <Card style={{ width: '100%', maxWidth: '420px', borderRadius: 10, backgroundColor: 'rgb(25, 27, 31)', border: '1px solid rgb(33, 36, 41)' }} p={0}>
          <Flex flexDirection='row' justifyContent='center' alignItems='center' color={'black'} p={16} borderBottom={'1px solid #D8D8D8'} mb={16}>
            <Text fontSize={'24px'} fontWeight={600} color={'white'} className='boxTitle'>Switch Network</Text>
          </Flex>
          <Box p={20} textAlign='center'>
            <Flex justifyContent='center' className='boxContent' mb={3}>You are on the wrong network.</Flex>
            <Flex justifyContent='center' className='boxContent' mb={1}>Let switch to BSC Testnet to continue.</Flex>
            <Flex justifyContent='center'>
              <Flex flexDirection='row' justifyContent='center' alignItems='center' className='walletOption' width='200px' mt={30} onClick={() => switchNetwork()}>
                <div className='optionConnectBtn'>Switch</div>
              </Flex>
            </Flex>
          </Box>   
        </Card>
      </Modal>
    </>
  )
}